export const name = "Self-love Edition"
export const menu = "Self-love"
export const edition = "Self-love Edition"
export const suggestedPlayer = "1 player"
export const color = {
    primary: {
        main:  '#efc5c3',
        contrastText: '#c10016',
    },
    secondary: {
        main: '#c10016'
    },
}
export const levels = ["Self-love", "Final Card"]
export const isExpansion = false

export const backDesc = [
    "Time to fall in love\n with myself ❤️"
]

export const instruction = [
    "Self-love is about calling ourselves on our own stuff, not just everybody's else's. It's about being kind to ourselves, even when we mess up. And appreciating ourselves, even when no one else does.",
    "Add this edition to your self-love practice. Answer these questions at your own pace. Journal your answers or play with a friend who is also on their self-love journey. Revisit these questions as often as you need.",
    "The more we love ourselves, the easier it becomes to give and receive love from others.",
    "Ready?",
]

export const level1 = [ // 51 cards
    "What belief about myself is holding me back the most? (Replace with a positive affirmation.)",
    "What am I proudest of myself\n for saying \"no\" to recently?", //
    "Am I avoiding any hard conversations with myself? If so, what comes to mind?",
    "What mistake of mine taught me the most recently? What did it teach me?",
    "What titles would you give this chapter of your self-love journey?",
    "What would I never want to change about myself? (Be specific!)",
    "What part(s) of myself have I felt the need to change in the past that I now embrace?",
    "What does self-love mean\n to me? What does it not\n mean to me? (Get specific.)", //
    "What did I give too much energy to a year ago that I can laugh at now?",
    "What can I take responsibility for that I've been placing on someone else?",
    "What do I want to learn more about in this chapter in my life? (Take time this week to explore this topic.)",
    "Do I have a clear picture of who I want to be this time next year? What's one small step I can towards becoming that person?",
    "When was the last time I shared my truth, even though it felt risky?",
    "Fill in the blank: Sometimes I forget how good I am at _________.",
    "What do I want to stop\n apologizing for?", //
    "What did I learn about myself this week?",
    "What am I not willing to settle for in relationships today, that I allowed not too long ago?",
    "When was the last time someone helped me appreciate a part of myself that feels hard for me to love?",
    "How do I want to be loved by somebody else? Describe in detail. Do you love yourself in this way? (Answer honestly)",
    "What boundary would benefit me the most to set with myself? Why haven't I set it yet?",
    "What do I wish someone would say to me in this current moment? (Give yourself that validation.)",
    "Is there anything I've been beating myself up about? What does having empathy for myself look like in this situation?",
    "What feedback forced me to grow recently, even if it was hard to hear in the moment?",
    "When was the last time I felt most in my element? What was I doing?",
    "How has my confidence increased with age?",
    "What can I offer to a friendship that I'm most excited to give?",
    "What is my favorite thing about the age I am today?",
    "When was the last time I earned my own trust? How did I earn it?",
    "What was the most genuine thank you I've received recently? What was it for?",
    "What compliment do I hear most that isn't about my physical appearance?",
    "What's the biggest improvement I've seen in myself this past year?",
    "How have I been underselling myself, perhaps unintentionally?",
    "What am I proudest of myself for recently, even if no one else has let me know?",
    "Who inspires me to become a better version of myself? How do they inspire me?",
    "Who do I compare myself most to? Why them? How does the comparison fuel me? How does it drain me?",
    "When was the last time I earned my own respect? Explain.",
    "How have I neglected myself recently? What's one small way I can make it up to myself today?",
    "When do I feel my best? What am I wearing? What am I doing? (Create that day for yourself as soon as possible.)",
    "What haven't I given myself\n permission to feel recently?", //
    "What's a \"flaw\" I've learned to appreciate about myself overtime?",
    "What are three things I love about my physical appearance? (Permission to brag!)",
    "When was the last time I pleasantly surprised myself? Explain.",

    "Wild Card Who's helped me love myself more? (Let them know!)",
    "Wild Card What are three things I'm most grateful for in this present moment? Write them out.",
    "Wild Card Who's done a great job at loving me? (Tell them thank you)",
    "Wild Card Write out one thing you appreciate about the body part you're most insecure about.",
    "Wild Card Write out an affirmation you need to hear most in this current moment. Repeat it everyday this week.",
    "Reminder Replace \"That was\n so stupid of me\"\n with \"That was\n so human of me.\"",
    "Reminder You deserve to\n take a breath. Relax\n for a moment. You've\n made it this far.\n Take that in.", //
    "Reminder The more you love\n yourself the better\n your relationships\n with everyone else\n will be.",
]

export const finalCard = [
    "Write a love letter to\n yourself. Take as much time\n as you need. Place it somewhere\n safe. Read it when you need\n it most.", //
]